import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconSubstractComponent } from "./med-icon-substract.component";

@NgModule({
  declarations: [
    MedIconSubstractComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconSubstractComponent,
  ],
})
export class MedIconSubstractModule { }
